import {Config, Environment} from "./config";

export const staging: Config = {
    environment: Environment.STAGING,
    showEnvLabel: false,
    server: "https://pre-live-backend.eevie.pet.cloud.audi",
}